import {collection, field, transientField} from "@fedeltapointofsale/data-client";
import {ReportData} from "../../../reports/report.data";
import {SellableReportSelectionData} from "../../../catalogue/sellable/controls/sellable-report-selection-control.component";

export class BestWorstSellersReportData extends ReportData<BestWorstSellersReportData> {
    @collection() groupBy: string[] = ["none"];
    @field exclusive: boolean = true;
    @field best: boolean = true;
    @field orderBy: string = "Quantity";
    @field limit: number = 10;
    @collection(SellableReportSelectionData) sellables: SellableReportSelectionData[];
}
